import { combineReducers } from 'redux'
import { 
  DATA_PENGADUAN
} from '../actions/dashboardPengaduanAction';

const dataPengaduanReduc = (state = {isLoad:false, data:{}, err:{stat:false,msg:''}, success:false}, action) => {
  switch (action.type) {
      case DATA_PENGADUAN:
      return {isload:action.load, data:action.val, err:action.error,success:action.success}
      default:
      return state
  }
}

const dashboardPengaduanReducer = combineReducers({
  dataPengaduanReduc
})

export default dashboardPengaduanReducer